import React, { useContext, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../../constants'
import { StickerBlock } from '../../../blocks'
import { TrashIcon } from '../../../icons'
import { CreationToolUploadContext } from '../../manager'
import { CreationToolUploadSource } from '../../types'

const Container = styled(StickerBlock)`
    align-items: center;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    display: flex;
    flex-shrink: 0;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: 50px;

    canvas {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
`

const RemoveButton = styled.div`
    align-items: center;
    background: rgba(0, 0, 0, 0.9);
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    transition: opacity 0.15s ease-out;
    width: 100%;

    svg {
        width: 34px;
    }

    svg path:first-child {
        transition: transform 0.15s ease-out;
    }

    &:hover svg path:first-child {
        transform: rotate(-30deg) translate3d(-20%, 10%, 0);
    }
`

type Props = {
    source: CreationToolUploadSource
    showRemoveIcon?: boolean
}

const CreationUploadItemIcon = ({ source: uploadSource, showRemoveIcon }: Props) => {
    const { removeUploadSource } = useContext(CreationToolUploadContext)
    const previewRef = useRef<HTMLCanvasElement>(null)
    const { source } = uploadSource

    const onRemove = () => {
        removeUploadSource(uploadSource.id)
    }

    useEffect(() => {
        if (!previewRef.current || !source.preview) return

        const preview = source.preview
        const canvas = previewRef.current
        const context = canvas.getContext('2d')

        canvas.width = Math.min(preview.width, preview.height)
        canvas.height = canvas.width
        context?.drawImage(preview, -(preview.width - canvas.width) / 2, -(preview.height - canvas.height) / 2)
    }, [previewRef, source])

    return (
        <Container>
            <canvas ref={previewRef} />
            <RemoveButton style={{ opacity: showRemoveIcon ? 1 : 0 }} onClick={onRemove}>
                <TrashIcon />
            </RemoveButton>
        </Container>
    )
}

export default CreationUploadItemIcon
